import React, { useState } from 'react';
import AppearanceSettings from './AppearanceSettings';

const SystemSettings = ({ onClose, user }) => {
  const [showAppearance, setShowAppearance] = useState(false);

  if (showAppearance) {
    return <AppearanceSettings onClose={() => setShowAppearance(false)} user={user} />;
  }

  const systemSettings = [
    { 
      icon: '🎨', 
      iconBg: 'bg-pink-100 dark:bg-pink-900', 
      iconColor: 'text-pink-600 dark:text-pink-400',
      label: 'Appearance', 
      onClick: () => setShowAppearance(true)
    },
    { 
      icon: '🔔', 
      iconBg: 'bg-yellow-100 dark:bg-yellow-900', 
      iconColor: 'text-yellow-600 dark:text-yellow-400',
      label: 'Notifications', 
      onClick: () => console.log('Notifications clicked')
    },
    { 
      icon: '📅', 
      iconBg: 'bg-red-100 dark:bg-red-900', 
      iconColor: 'text-red-600 dark:text-red-400',
      label: 'Calendars', 
      onClick: () => console.log('Calendars clicked')
    }
  ];

  return (
    <div className="p-4 space-y-2">
      {systemSettings.map((item, idx) => (
        <button
          key={idx}
          onClick={item.onClick}
          className="w-full flex items-center justify-between p-4 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-2xl transition-all border border-gray-100 dark:border-gray-700"
        >
          <div className="flex items-center space-x-4">
            <div className={`w-14 h-14 ${item.iconBg} rounded-2xl flex items-center justify-center flex-shrink-0 transition-colors`}>
              <span className="text-2xl">{item.icon}</span>
            </div>
            <div className="text-left">
              <div className="font-semibold text-gray-900 dark:text-white text-base">
                {item.label}
              </div>
            </div>
          </div>
          <span className="text-gray-400 dark:text-gray-500 text-xl">›</span>
        </button>
      ))}
    </div>
  );
};

export default SystemSettings;
